// extracted by mini-css-extract-plugin
export default {"root":"AddProductTimeSlot_root__hIosU","add-icon":"AddProductTimeSlot_add-icon__sCjvZ"};